
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { X } from 'lucide-react';
import { CustomFoodForm as CustomFoodFormType } from './types';

interface CustomFoodFormProps {
  customFood: CustomFoodFormType;
  onCustomFoodChange: (field: keyof CustomFoodFormType, value: string | number) => void;
  onAddCustomFood: () => void;
  onCancel: () => void;
}

const CustomFoodForm: React.FC<CustomFoodFormProps> = ({ 
  customFood, 
  onCustomFoodChange, 
  onAddCustomFood, 
  onCancel 
}) => {
  return (
    <Card className="mt-3 border border-blue-200">
      <CardContent className="p-3">
        <div className="flex justify-between items-center mb-2">
          <h4 className="font-medium">Crear alimento personalizado</h4>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 w-8 p-0" 
            onClick={onCancel}
          >
            <X size={16} />
          </Button>
        </div>
        
        <div className="space-y-2">
          <div>
            <label htmlFor="custom-name" className="text-xs text-gray-600 block">Nombre:</label>
            <Input 
              id="custom-name" 
              value={customFood.name} 
              onChange={(e) => onCustomFoodChange('name', e.target.value)} 
              className="mt-1"
              placeholder="Ej: Mi receta casera"
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label htmlFor="custom-calories" className="text-xs text-gray-600 block">Calorías (kcal):</label>
              <Input 
                id="custom-calories" 
                type="number" 
                value={customFood.calories}
                onChange={(e) => onCustomFoodChange('calories', Number(e.target.value))}
                className="mt-1"
              />
            </div>
            <div>
              <label htmlFor="custom-protein" className="text-xs text-gray-600 block">Proteína (g):</label>
              <Input 
                id="custom-protein" 
                type="number" 
                step="0.1"
                value={customFood.protein}
                onChange={(e) => onCustomFoodChange('protein', Number(e.target.value))}
                className="mt-1"
              />
            </div>
            <div>
              <label htmlFor="custom-carbs" className="text-xs text-gray-600 block">Carbohidratos (g):</label>
              <Input 
                id="custom-carbs" 
                type="number" 
                step="0.1"
                value={customFood.carbs}
                onChange={(e) => onCustomFoodChange('carbs', Number(e.target.value))}
                className="mt-1"
              />
            </div>
            <div>
              <label htmlFor="custom-fat" className="text-xs text-gray-600 block">Grasas (g):</label>
              <Input 
                id="custom-fat" 
                type="number" 
                step="0.1"
                value={customFood.fat}
                onChange={(e) => onCustomFoodChange('fat', Number(e.target.value))}
                className="mt-1"
              />
            </div>
          </div>
          <Button 
            className="w-full mt-2" 
            onClick={onAddCustomFood}
          >
            Crear y seleccionar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomFoodForm;
